/* eslint-disable default-case */

import { GoogleMap } from '@gameday/react-components/components'
import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'

import { getCountryData } from '../../../functions'
import { getSubdivisions } from '../../../functions/address'

const Address = ({
  errorText,
  id,
  label,
  isRequired,
  onChange,
  values,
  endpoint,
  googleApiKey,
  name,
  dataTestId,
  hierarchyCountryCode,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  ...rest
}) => {
  // biome-ignore lint/complexity/useOptionalChain: TODO
  const [street, setStreet] = useState((values && values.street) || '')
  // biome-ignore lint/complexity/useOptionalChain: TODO
  const [street2, setStreet2] = useState((values && values.street2) || '')
  // biome-ignore lint/complexity/useOptionalChain: TODO
  const [city, setCity] = useState((values && values.city) || '')
  // biome-ignore lint/complexity/useOptionalChain: TODO
  const [state, setState] = useState((values && values.state) || '')
  // biome-ignore lint/complexity/useOptionalChain: TODO
  const [country, setCountry] = useState((values && values.country) || '')
  // biome-ignore lint/complexity/useOptionalChain: TODO
  const [postalcode, setPostalcode] = useState((values && values.postalcode) || '')
  const [subdivisions, setSubdivisions] = useState([])

  const val = values || {}
  const err = errorText || {}
  const countryName = val.country

  useEffect(() => {
    // call onChange when there's values changed or when values are cleared
    if (street || street2 || city || state || country || postalcode || !isEmpty(values)) {
      onChange({
        street,
        street2,
        city,
        state,
        country,
        postalcode,
      })
    }
  }, [street, street2, city, state, country, postalcode])

  useEffect(() => {
    // biome-ignore lint/complexity/useOptionalChain: TODO
    if ((country && country.code) || countryName) {
      getSubdivisions(country.code || getCountryData(countryName).code, endpoint).then(data => {
        setSubdivisions(
          data.map(sd => ({
            id: sd.subdivisionName,
            name: sd.subdivisionName,
          }))
        )
      })
    }
  }, [country, countryName])

  const addressDefinition = {
    country: {
      fieldName: 'country',
      label: 'Select Country',
      value: val.country,
      errorText: err.country,
      isRequired,
    },
    street: {
      fieldName: 'street',
      label: 'Street Address',
      value: val.street,
      errorText: err.street,
      isRequired,
    },
    street2: {
      fieldName: 'street2',
      label: 'Address 2',
      value: val.street2,
      errorText: err.street2,
    },
    suburb: {
      fieldName: 'city',
      placeholder: 'Suburb',
      value: val.city,
      errorText: err.city,
      isRequired,
    },
    state: {
      fieldName: 'state',
      defaultValue: 'Select State/Province',
      value: val.state,
      errorText: err.state,
      isRequired,
    },
    postalCode: {
      fieldName: 'postalcode',
      placeholder: 'Postal Code',
      value: val.postalcode,
      errorText: err.postalcode,
      isRequired,
    },
  }

  return (
    <GoogleMap
      id={id}
      apiKey={googleApiKey}
      label={label}
      name={name}
      enableManualEntry
      enableSearch
      addressDefinition={addressDefinition}
      subDivisions={subdivisions}
      inputProps={{
        withBorder: true,
      }}
      groupAddressFields
      defaultEntryMode="manual"
      dataTestId={dataTestId}
      hierarchyCountryCode={hierarchyCountryCode}
      onChange={({ address }, fieldKey) => {
        if (!fieldKey) return
        if (fieldKey === 'place') {
          setCountry(address.country)
          setStreet(address.street)
          setStreet2(address.street2)
          setCity(address.suburb)
          setState(address.state)
          setPostalcode(address.postalCode)
        } else {
          switch (fieldKey) {
            case 'country':
              setCountry(address.country)
              break
            case 'street':
              setStreet(address.street)
              break
            case 'street2':
              setStreet2(address.street2)
              break
            case 'suburb':
              setCity(address.suburb)
              break
            case 'state':
              setState(address.state)
              break
            case 'postalCode':
              setPostalcode(address.postalCode)
              break
          }
        }
      }}
    />
  )
}

export default Address
